import APIClient from '@/shared/http/clients/api'

const resourceName = 'OcorrenciaCasa'
const APIRealEstate = process.env.APIBaseURLRealEstate

// Liga um chamado a uma casa (ObraVinculoSAP)
const Vincular = (ocorrenciaId, vinculoId, data = {}, config = {}) =>
  APIClient.put(`${APIRealEstate}/${resourceName}/${ocorrenciaId}/vincular/${vinculoId}`, data, config)

// Desfaz o vínculo do chamado
const Desvincular = (ocorrenciaId, config = {}) =>
  APIClient.delete(`${APIRealEstate}/${resourceName}/${ocorrenciaId}/vincular`, config)

// Chamados de uma casa
const GetChamadosDaCasa = (vinculoId, data = {}, config = {}) =>
  APIClient.get(`${APIRealEstate}/${resourceName}/casa/${vinculoId}/chamados`, data, config)

const OcorrenciaCasaRepository = {
  Vincular,
  Desvincular,
  GetChamadosDaCasa
}

export default OcorrenciaCasaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/ocorrenciaCasa.js